import { ShipmentStatus } from '../../interfaces';
import './StatusChip.scss';

interface Props {
  status: ShipmentStatus;
}

export default function StatusChip({ status }: Props) {
  return (
    <div className={`StatusChip ${status.replace(' ', '')}`}>
      {status === ShipmentStatus.ALL ? 'All' : status}
    </div>
  );
}
